import * as React from 'react';
import * as Redux from 'redux';
import { htmlEncode } from '../../functions/html-encode';
import MaskedInput from 'react-text-mask'

export interface ITextboxProps {
    id: string;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FormEvent<HTMLInputElement>) => void;
    hasError?: boolean;
    errorText?: string;
    labelText?: string;
    defaultValue?: string;
    placeHolder?: string;
    customClasses?: string;
    required?: boolean;
    value?: string;
    autoFocus?: boolean;
    pattern?: string;
    inputMask?: any;
    password?: boolean;
}

/// <summary>
/// This class can be used for a textbox with built in styling and handling for the error state
/// </summary>
/// <param name="id">The html id of the textbox. Required to associate the label with the textbox</param>
/// <param name="onInput">The callback function for when the textbox input changes. Current textbox text should be saved in a state variable</param>
/// <param name="hasError">Determines whether or not to show the error state (optional, default=false)</param>
/// <param name="errorText">The error message displayed when the textbox is in its error state (optional, default='')</param>
/// <param name="labelText">The text shown for the label (optional, default='')</param>
/// <param name="defaultValue">Default text to display in the textbox (optional, default='')</param>
/// <param name="placeHolder">Default placeholder text (optional, default='')</param>
/// <param name="customClasses">Used to supply any additional classes to the surrounding textbox div (optional, default='')</param>
/// <returns></returns>
export class Textbox extends React.Component<ITextboxProps, any> {
    static defaultProps = {
        onInput: () => { },
        onKeyPress: () => { },
        onKeyDown: () => { },
        onBlur: () => { },
        onFocus: () => { },
        hasError: false,
        errorText: '',
        labelText: '',
        defaultValue: '',
        value: '',
        placeHolder: '',
        customClasses: '',
        required: false,
        autoFocus: false,
        pattern: '',
        inputMask: [],
        password: false
    }

    GetClassNames() {
        let FORM_CLASSES = " form-element form-element-required";
        let INVALID_CLASS = " form-element-invalid";
        let classes = this.props.customClasses + FORM_CLASSES;

        if (this.props.hasError)
            classes += INVALID_CLASS;

        return classes;
    }

    onInputHandler = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onInput(e);
    }

    onKeyPressHandler = (e: any) => {
        this.props.onKeyPress(e);
    }

    onKeyDownHandler = (e: any) => {
        this.props.onKeyDown(e);
    }

    onBlurHandler = (e: any) => {
        this.props.onBlur(e);
    }

    onFocusHandler = (e: any) => {
        this.props.onFocus(e);
    }

    renderMaskedInput = () => {
        const { value, defaultValue, placeHolder, hasError, errorText, labelText, customClasses, required, id, autoFocus, pattern, inputMask } = this.props;

        return <MaskedInput
            mask={inputMask}
            id={id}
            type={"text"}
            className="form-element-input"
            autoFocus={autoFocus}
            defaultValue={value != null && value.length > 0 ? undefined : defaultValue}
            onChange={this.onInputHandler}
            onKeyDown={this.onKeyDownHandler}
            onBlur={this.onBlurHandler}
            onFocus={this.onFocusHandler}
            value={value == null || value.length <= 0 ? undefined : value}
            onKeyPress={this.onKeyPressHandler}
            placeholder={placeHolder}
             />
    }

    renderInput = () => {
        const { value, defaultValue, placeHolder, hasError, errorText, labelText, customClasses, required, id, autoFocus, pattern, inputMask } = this.props;
        const type = this.props.password ? 'password' : 'text'
        
        return <input
            id={id}
            type={type}
            className="form-element-input"
            autoFocus={autoFocus}
            defaultValue={value != null && value.length > 0 ? undefined : defaultValue}
            onChange={this.onInputHandler}
            onKeyDown={this.onKeyDownHandler}
            onBlur={this.onBlurHandler}
            onFocus={this.onFocusHandler}
            value={value == null ? undefined : value}
            onKeyPress={this.onKeyPressHandler}
            placeholder={placeHolder}
             />
    }

    render() {
        const { value, defaultValue, placeHolder, hasError, errorText, labelText, customClasses, required, id, autoFocus, pattern, inputMask } = this.props;

        const label = <label className="form-element-label" htmlFor={id}>
            <span className="form-element-label-main">{labelText}</span>
        </label>

        return (
            <div className={this.GetClassNames()}>
                { labelText && label }
                {
                    inputMask.length > 0
                        ? this.renderMaskedInput()
                        : this.renderInput()
                }
                { hasError &&
                    <div className="form-element-error">
                        <div className="form-element-error-text-wrapper">
                            <div className="form-element-error-text" dangerouslySetInnerHTML={htmlEncode(errorText)}>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}